import DEFAULT_OPERATIONS from '@/hooks/SearchPage/searchPage.gql';
import mergeOperations from '@/util/shallowMerge';
import { useQuery } from '@apollo/client';
import { useSearchParams } from 'next/navigation';

export const useGetFilterData = () => {
  const operations = mergeOperations(DEFAULT_OPERATIONS);
  const { getProductFiltersBySearchQuery } = operations;

  const searchParams = useSearchParams();

  const search = searchParams.get('query');

  const { data: filterData, loading: filterLoading } = useQuery(getProductFiltersBySearchQuery, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      search,
    },
    onCompleted: async data => {},
  });
  let filters = filterData?.products?.aggregations || null;
  if (filters) {
    filters = filters.filter(({ label }) => label !== 'Price' && label !== 'Category' && !label.includes('Size'));
  }
  const shouldShowFilterButtons = filters && filters.length;
  const shouldShowFilterShimmer = filters === null;

  return {
    filters,
    shouldShowFilterButtons,
    shouldShowFilterShimmer,
    filterLoading,
  };
};
